import { fromJS, Map } from 'immutable';
import { message } from 'antd';

import {
  CLEAR_STATE,
  RELOAD_BOOKING,
  CANCEL_BOOKING,
  LOAD_BOOKING_SUCCESS,
  LOAD_BOOKING_ERROR,
  UPDATE_BOOKING,
  CHARGE_PAYMENT_ERROR,
  CHARGE_PAYMENT_SUCCESS,
  ADD_NOTE_SUCCESS,
  AUTH_USER_SUCCESS,
  EDIT_CUSTOMER_DETAILS_SUCCESS,
  EDIT_CUSTOMER_PROMO_SUCCESS,
  JOB_INVITE_SUCCESS,
  EDIT_GARAGE_BILL_STATUS_REQUEST,
  EDIT_GARAGE_BILL_STATUS_SUCCESS,
  EDIT_GARAGE_BILL_STATUS_FAILURE,
  BOOKING_CHANGED,
} from './constants';

import { SEND_QUOTE_TO_CUSTOMER, UPDATE_TO_CUSTOMER_REVIEW } from './WorkDetails/constants';
import { mergeWorkCompleteReadiness } from './ServiceSheetMissingAlert/logic';

export const initialState = fromJS({
  booking: null,
  authUser: null,
  loading: false,
  bookingReloading: false,
  error: null,
  sendQuoteLoading: false,
  bookingChanged: false,
});

function bookingReducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_STATE:
      return state
        .set('booking', null)
        .set('authUser', null)
        .set('loading', false)
        .set('bookingReloading', false)
        .set('error', null)
        .set('bookingChanged', false);
    case RELOAD_BOOKING:
      return state.set('bookingReloading', true);
    case CANCEL_BOOKING:
      return state.set('bookingReloading', true);
    case LOAD_BOOKING_SUCCESS:
      return state
        .set('booking', fromJS(mergeWorkCompleteReadiness(state.get('booking'), action.booking)))
        .set('loading', false)
        .set('bookingReloading', false)
        .set('sendQuoteLoading', false)
        .set('bookingChanged', false);
    case LOAD_BOOKING_ERROR:
      message.error(action.error);
      return state.set('loading', false).set('bookingReloading', false).set('bookingChanged', false);
    case UPDATE_BOOKING:
      return state.set('booking', fromJS(action.booking));
    case BOOKING_CHANGED:
      return state.set('bookingChanged', action.isBookingChanged);
    case CHARGE_PAYMENT_ERROR:
      message.error(action.error);
      return state;
    case CHARGE_PAYMENT_SUCCESS:
      if (action.payload.statusCode >= 400) {
        message.error(action.payload.message);
      } else {
        message.info(action.payload.message);
      }
      return state;
    case AUTH_USER_SUCCESS:
      return state.setIn(['authUser'], action.user);
    case JOB_INVITE_SUCCESS:
      return state.updateIn(['booking', 'garageInvites'], (garageInvites) => {
        const IdToReplace = garageInvites.findIndex(
          (invite) => invite.get('invitationId') == action.invite.invitationId
        );
        if (IdToReplace >= 0) {
          return garageInvites.set(IdToReplace, fromJS(action.invite));
        }
        return garageInvites.push(fromJS(action.invite));
      });
    case ADD_NOTE_SUCCESS:
      return state.updateIn(['booking', 'notes'], (notes) => notes.unshift(action.payload));
    case EDIT_CUSTOMER_DETAILS_SUCCESS:
      return state
        .setIn(['booking', 'customerId'], action.customer.id)
        .setIn(['booking', 'customer'], Map(action.customer));
    case EDIT_CUSTOMER_PROMO_SUCCESS:
      return state;
    case EDIT_GARAGE_BILL_STATUS_REQUEST:
      return state.set('loading', true);
    case EDIT_GARAGE_BILL_STATUS_SUCCESS:
      return state
        .setIn(['booking', 'garageBills'], fromJS(action.invoiceData))
        .setIn(['booking', 'garagePaymentStatus'], action.invoiceData[0].invoiceStatus)
        .set('loading', false);
    case EDIT_GARAGE_BILL_STATUS_FAILURE:
      message.error(action.error);
      return state.set('loading', false);
    case SEND_QUOTE_TO_CUSTOMER:
      return state.set('sendQuoteLoading', true);
    case UPDATE_TO_CUSTOMER_REVIEW:
      return state.set('sendQuoteLoading', true);
    default:
      return state;
  }
}

export default bookingReducer;
